import {AfterContentInit, Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-collapser-text',
  imports: [],
  templateUrl: './collapser-text.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './collapser-text.component.scss'
})
export class CollapserTextComponent implements AfterContentInit {
  @Input() text: string = '';
  @Input() maxLength = 100;

  canToggle = false;
  expanded = false;
  collapsedText = '';

  ngAfterContentInit(): void {
    if (this.maxLength < this.text.length) {
      this.canToggle = true;
    }

    setTimeout(() => {
      this.refresh();
    });
  }

  refresh(): void {
    if (this.expanded) {
      this.collapsedText = this.text;
    } else {
      this.collapsedText = this.text.substring(0, this.maxLength).trim();
    }
  }

  canExpand(): boolean {
    return this.canToggle && !this.expanded;
  }

  canCollapse(): boolean {
    return this.canToggle && this.expanded;
  }

  expand(): void {
    this.expanded = true;
    this.refresh();
  }

  collapse(): void {
    this.expanded = false;
    this.refresh();
  }
}
